import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loading } from "@/components/States";
import { Users, UserPlus, AlertTriangle, CalendarCheck, Package, Flag, Building2, ArrowRight } from "lucide-react";

export default function Overview() {
  const nav = useNavigate();
  const { data, isLoading } = useQuery({ queryKey: ["overview"], queryFn: async () => (await api.get("/manager/overview")).data });
  if (isLoading) return <Loading />;

  const stats = [
    { label: "Unidades", value: data.units, icon: Building2, color: "text-primary" },
    { label: "Moradores cadastrados", value: data.residents, icon: Users, color: "text-primary" },
    { label: "Aguardando aprovação", value: data.pending, icon: UserPlus, color: "text-yellow-400", link: "/gestao/moradores" },
    { label: "Alertas ativos", value: data.alerts, icon: AlertTriangle, color: "text-red-400", link: "/gestao/comunicacao" },
    { label: "Reservas hoje", value: data.reservations_today, icon: CalendarCheck, color: "text-emerald-400", link: "/gestao/servicos" },
    { label: "Encomendas aguardando", value: data.packages, icon: Package, color: "text-primary", link: "/gestao/servicos" },
    { label: "Publicações denunciadas", value: data.reported, icon: Flag, color: "text-red-400", link: "/gestao/comunidade" },
  ];

  return (
    <div className="space-y-6">
      <div>
        <p className="text-sm text-muted-foreground">{data.condo?.name}</p>
        <h1 className="font-display font-bold text-3xl tracking-tight">Visão geral</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
        {stats.map((s) => (
          <button key={s.label} onClick={() => s.link && nav(s.link)} data-testid={`stat-${s.label.split(" ")[0].toLowerCase()}`} className={`glass rounded-3xl p-5 text-left card-hover ${s.link ? "cursor-pointer" : "cursor-default"}`}>
            <div className="flex items-center justify-between">
              <div className="w-10 h-10 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center"><s.icon className={`w-5 h-5 ${s.color}`} /></div>
              {s.link && <ArrowRight className="w-4 h-4 text-muted-foreground" />}
            </div>
            <p className="font-display font-extrabold text-3xl mt-3">{s.value}</p>
            <p className="text-xs text-muted-foreground mt-0.5">{s.label}</p>
          </button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <button onClick={() => nav("/gestao/comunicacao")} data-testid="quick-comunicado" className="rounded-3xl brand-gradient p-6 text-left glow-primary active:scale-[0.99] transition-transform">
          <Megaphone /><p className="font-display font-bold text-lg text-white mt-2">Novo comunicado</p>
          <p className="text-sm text-white/85">Fale com todo o condomínio em segundos.</p>
        </button>
        <button onClick={() => nav("/gestao/comunicacao")} data-testid="quick-alerta" className="rounded-3xl p-6 text-left border border-red-500/30 bg-red-500/5 card-hover">
          <AlertTriangle className="text-red-400" /><p className="font-display font-bold text-lg mt-2">Criar alerta crítico</p>
          <p className="text-sm text-muted-foreground">Avise imediatamente sobre emergências.</p>
        </button>
      </div>
    </div>
  );
}

function Megaphone() { return <div className="text-white text-2xl">📢</div>; }
